import { Directive, forwardRef, Input, StaticProvider } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators } from "@angular/forms";
import { MiProValidators } from "@mipro/validators/mipro-validators";

const REQUIRED_FIELD_VALIDATOR: StaticProvider = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => RequiredFieldValidatorDirective),
    multi: true
};

@Directive({
    selector:
        ":not([type=checkbox])[requiredField][formControlName],:not([type=checkbox])[requiredField][formControl],:not([type=checkbox])[requiredField][ngModel]",
    providers: [REQUIRED_FIELD_VALIDATOR]
})
export class RequiredFieldValidatorDirective implements Validator {
    private _validator: (control: AbstractControl) => ValidationErrors;

    @Input() set requiredField(field: string) {
        this._validator = MiProValidators.requiredField(field);
        this._onInputChange();
    }

    validate(control: AbstractControl): ValidationErrors {
        return this._validator(control);
    }

    registerOnValidatorChange(fn: () => void): void {
        this._onInputChange = fn ?? this._onInputChange;
    }

    private _onInputChange = () => {};
}
